import Container from '@anm/components/Container';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const containerWrapperOnMobile = media.phone`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 26px;
    line-height: 35px;
  }
`;

const ContainerWrapper = styled(Container)`
  margin-bottom: 6px;
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 32px;
    margin-bottom: 20px;
  }
  ${containerWrapperOnMobile};
`;

export const Text = styled.p`
  font-size: 16px;
  margin: 48px 0 0;
  line-height: 28px;
`;

export default ContainerWrapper;
